import { Link } from 'react-router-dom';

function HMSidebar() {
  return (
    <div className="projects-sidebar">
      <h2>Projects Show Case</h2>
      <ul>
        <li><Link to="/semi-d">Semi-D</Link></li>
        <li><Link to="/landed">Landed</Link></li>
        <li><Link to="/commercial">Commercial</Link></li>
        <li><Link to="/condominium">Condominium</Link></li>
        <li><Link to="/gallery" className="view-all">View All</Link></li>
      </ul>
    </div>
  );
}

export default HMSidebar;